<template>
  <v-row no-gutters>
    <v-col class="pa-2" cols="12">
      <v-slider
        v-model="computedValue.qrOptions.typeNumber"
        append-icon="mdi-numeric"
        label="دقت کیوآر"
        max="32"
        min="0"
        thumb-label
        track-color="grey"
        @input="$emit('update', true)"
      >
        <template v-slot:thumb-label="{ value }">
          <div
            class="d-flex align-center justify-center"
            style="
              width: 20px;
              height: 20px;
              background-color: rgba(12, 15, 26, 0.7);
              border-radius: 50%;
            "
          >
            {{ value }}
          </div>
        </template>
      </v-slider>
    </v-col>

    <v-col class="pa-2" cols="12" md="6">
      <div class="rowinfo">
        <v-autocomplete
          v-model="computedValue.qrOptions.mode"
          :items="modeItems"
          dense
          hide-details
          label="حالت"
          class="contentinfo"
          outlined
          @input="$emit('update', true)"
        />
        <help-info
          :element-name="`${serviceName}-${componentName}-computedValue-qrOptions-mode`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="حالت"
        />
      </div>
    </v-col>

    <v-col class="pa-2" cols="12" md="6">
      <div class="rowinfo">
        <v-autocomplete
          v-model="computedValue.qrOptions.errorCorrectionLevel"
          :items="correctionItems"
          dense
          hide-details
          label="سطح اصلاح خطا"
          class="contentinfo"
          outlined
          @input="$emit('update', true)"
        />
        <help-info
          :element-name="`${serviceName}-${componentName}-computedValue-qrOptions-errorCorrectionLevel`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="سطح اصلاح خطا"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "qrCodeOptions",

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeOptions",
    modeItems: [
      { text: "عددی", value: "Numeric" },
      { text: "الفبایی", value: "Alphanumeric" },
      { text: "بایت", value: "Byte" },
      { text: "Kanji", value: "Kanji" },
    ],
    correctionItems: ["L", "M", "Q", "H"],
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
